import { useCallback, useState } from 'react';

export const useContactSupportForm = () => {
    const [canCancelRequest, setCanCancelRequest] = useState(false);
    const [isContactSupportFormVisible, setIsContactSupportFormVisible] = useState(false);
    const [isRequestedPopupVisible, setIsRequestedPopupVisible] = useState(false);

    const handleShowContactSupportForm = useCallback(() => {
        // TODO: Will be implemented in a separate task

        setIsContactSupportFormVisible(true);
    }, []);

    const handleHideContactSupportForm = useCallback(() => {
        // TODO: Will be implemented in a separate task

        setIsContactSupportFormVisible(false);
    }, []);

    const handleShowEmailChangeRequestedPopup = useCallback(() => {
        // TODO: Will be implemented in a separate task

        setCanCancelRequest(true);
        setIsRequestedPopupVisible(true);
    }, []);

    const handleHideEmailChangeRequestedPopup = useCallback(() => {
        // TODO: Will be implemented in a separate task

        setIsRequestedPopupVisible(false);
    }, []);

    const handleCancelRequest = useCallback(() => {
        // TODO: Will be implemented in a separate task

        setCanCancelRequest(false);
    }, []);

    return {
        canCancelRequest,
        handleCancelRequest,
        isContactSupportFormVisible,
        isRequestedPopupVisible,
        handleShowContactSupportForm,
        handleHideContactSupportForm,
        handleShowEmailChangeRequestedPopup,
        handleHideEmailChangeRequestedPopup,
    };
};

export const useEmailChangeForm = () => {
    const [isEmailChangeFormVisible, setIsEmailChangeFormVisible] = useState(false);

    const handleShowEmailChangeForm = useCallback(() => {
        // TODO: Will be implemented in a separate task

        setIsEmailChangeFormVisible(true);
    }, []);

    return {
        isEmailChangeFormVisible,
        handleShowEmailChangeForm,
    };
};
